/* eslint-disable no-unused-vars */
import { useState, useRef, useId } from 'react';
import { useParams } from 'react-router';
import * as S from './EditPlacementModal.styled';
import { CustomInput, Buttons } from 'components';
import { useFloating, flip, offset, FloatingArrow, arrow } from '@floating-ui/react';
import { Pen, DeleteIcon } from 'assets/icons';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { manageAppsAPI } from 'services/manageApps.service';

const NAME_CHAR_LIMIT = 100;

const EditPlacementModal = ({ name, id, status, placementNames }) => {
  const [text, setText] = useState(name);
  const arrowRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { pba_id } = useParams();
  const [upDatePlacement] = manageAppsAPI.useUpDatePlacementMutation();

  const { x, y, strategy, refs, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      flip(),
      offset(3),
      arrow({
        element: arrowRef,
      }),
    ],
    placement: 'top',
  });
  const nameIsUnique = placementNames.includes(text);
  const textLengthError = text.length > NAME_CHAR_LIMIT;

  const editBtnIsDisabled = text.trim() === name || !text || nameIsUnique || textLengthError;
  const [animationParent] = useAutoAnimate({ duration: 100 });

  const handleClickBtnOk = () => {
    upDatePlacement({ data: { name: text.trim(), id, status }, pba_id });
    setIsOpen(false);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setText(name);
  };
  const inputNameId = useId();
  const closeModalId = useId();
  const saveModalId = useId();
  return (
    <>
      {isOpen && <S.Slice onClick={handleCloseModal} />}
      <S.Container onClick={() => setIsOpen(!isOpen)} ref={refs.setReference}>
        <S.IconWrap isOpen={isOpen}>
          <Pen />
        </S.IconWrap>
      </S.Container>

      <S.ParentContainer ref={animationParent}>
        {isOpen && (
          <S.MenuContainer
            ref={refs.setFloating}
            style={{
              position: strategy,
              top: y ?? 10,
              left: x ?? 10,
              width: 'max-content',
            }}
          >
            <S.EditBox>
              <S.Header>Change Name:</S.Header>
              <S.EditContent>
                <CustomInput
                  id={inputNameId}
                  name={inputNameId}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  rightIconOnClick={() => setText('')}
                  rightIcon={text ? <DeleteIcon /> : null}
                  error={nameIsUnique || textLengthError}
                  errorText={`Name should be unique and no more than ${NAME_CHAR_LIMIT} characters`}
                  containerStyle={{ display: 'flex', flexDirection: 'column', height: '70px' }}
                />
              </S.EditContent>
              <S.BtnWrap>
                <Buttons.SecondaryNormal
                  style={{ width: '100%' }}
                  id={closeModalId}
                  onClick={handleCloseModal}
                >
                  Cancel
                </Buttons.SecondaryNormal>
                <Buttons.PrimaryNormal
                  style={{ width: '100%' }}
                  id={saveModalId}
                  onClick={handleClickBtnOk}
                  isDisabled={editBtnIsDisabled}
                >
                  Ok
                </Buttons.PrimaryNormal>
              </S.BtnWrap>
            </S.EditBox>
            <FloatingArrow ref={arrowRef} context={context} fill='#fff' />
          </S.MenuContainer>
        )}
      </S.ParentContainer>
    </>
  );
};

export default EditPlacementModal;
